import React, { useMemo } from 'react';
import Concept2WorkoutAnalysis from '../../components/rower/concept2/Concept2WorkoutAnalysis';
import { useConcept2Workout } from '../../hooks/useConcept2';
import { buildConcept2WorkoutSeries } from '../../utils/concept2WorkoutSeries';

interface Concept2WorkoutAnalysisPrototypePageProps {
  workoutId: string | null;
}

const Concept2WorkoutAnalysisPrototypePage: React.FC<Concept2WorkoutAnalysisPrototypePageProps> = ({
  workoutId,
}) => {
  const { data: workout, isLoading, isError } = useConcept2Workout(workoutId);

  const series = useMemo(() => {
    if (!workout) {
      return null;
    }

    return buildConcept2WorkoutSeries(
      workout.segments,
      workout.machine_type,
      workout.time_tenths,
      workout.strokes
    );
  }, [workout]);

  if (!workoutId) {
    return (
      <div className="flex h-full min-h-[480px] items-center justify-center p-6 text-sm text-content-muted">
        Select a Concept2 workout above to preview the chart.
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex h-full min-h-[480px] items-center justify-center p-6 text-sm text-content-muted">
        Loading workout data…
      </div>
    );
  }

  if (isError || !workout) {
    return (
      <div className="flex h-full min-h-[480px] items-center justify-center p-6 text-sm text-red-700">
        Could not load the selected Concept2 workout.
      </div>
    );
  }

  if (!series) {
    return (
      <div className="flex h-full min-h-[480px] items-center justify-center p-6 text-sm text-content-muted">
        This workout does not have enough stroke or split data to render the chart yet.
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-[720px] flex-col p-2 sm:p-4">
      <Concept2WorkoutAnalysis series={series} variant="chart" />
    </div>
  );
};

export default Concept2WorkoutAnalysisPrototypePage;
